import React from 'react'
import Logo from '../Logo/Logo'
import Socials from '../Socials/Socials'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-wrapper">
          <div className="footer-brand">
            <div className="footer-logo">
              <Logo />
            </div>
            <p className="footer-description">
              Республиканский медицинский информационно-аналитический центр
              Министерства здравоохранения Удмуртской Республики
            </p>
          </div>

          <section className="footer-section">
            <h3>Контакты</h3>
            <a href="tel:+73412787914">+7 (3412) 78-79-14</a>
            <a href="mailto:office@rmiac18.ru">office@rmiac18.ru</a>
            <Socials />
          </section>

          <section className="footer-section">
            <h3>Адрес</h3>
            <address>
              426076, Российская Федерация,<br />
              Удмуртская Республика, город Ижевск,<br />
              улица Свободы, 139
            </address>
          </section>

          <section className="footer-section footer-schedule">
            <h3>График работы РМИАЦ</h3>
            <p>
              Пн – Пт: с 8:00 до 17:00<br />
              Пт: с 8:00 до 16:00<br />
              Обед: с 12:00 до 13:00<br />
              Сб и Вс: выходные
            </p>
            <p>
              Прием руководителем граждан:<br />
              Ср: с 15:00 до 17:00 по предварительной записи.
            </p>
          </section>
        </div>

        <div className="footer-bottom">
          © 2026 БУЗ УР «РМИАЦ МЗ УР»
        </div>
      </div>
    </footer>
  )
}

export default Footer